import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Send, BellRing, Loader2 } from "lucide-react";

export default function PushSender() {
  const [message, setMessage] = useState("");
  const [code, setCode] = useState("");
  const [sending, setSending] = useState(false);

  const send = async () => {
    setSending(true);
    try {
      const r = await api.post("/admin/notify", {
        message: message.trim(),
        code: code.trim() || null,
      });
      toast.success(`Notifica inviata a ${r.data.sent} dispositivo/i`);
      setMessage("");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore invio notifica");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="push-sender" className="bg-black border border-amber-500/15 rounded-md p-4 space-y-3">
      <h3 className="font-mono-data text-xs text-amber-400/80 tracking-widest uppercase flex items-center gap-2">
        <BellRing className="w-3.5 h-3.5" /> Invia Notifica Push
      </h3>
      <div className="flex flex-wrap gap-3 items-end">
        <div className="flex-1 min-w-[220px]">
          <label className="text-[11px] text-slate-400 uppercase tracking-wider block mb-1.5">Messaggio</label>
          <input
            data-testid="push-message-input"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            maxLength={180}
            placeholder="Es. Nuovi segnali disponibili per il weekend!"
            className="w-full bg-black border border-amber-500/25 rounded-sm px-3 py-2 text-sm text-slate-200 focus:outline-none focus:border-amber-400"
          />
        </div>
        <div>
          <label className="text-[11px] text-slate-400 uppercase tracking-wider block mb-1.5">Codice (vuoto = tutti)</label>
          <input
            data-testid="push-code-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            maxLength={8}
            placeholder="ZSXXXXXX"
            className="w-32 bg-black border border-amber-500/25 rounded-sm px-3 py-2 font-mono-data text-sm text-amber-200 focus:outline-none focus:border-amber-400"
          />
        </div>
        <button
          data-testid="push-send-button"
          onClick={send}
          disabled={sending || message.trim().length < 2}
          className="px-4 py-2 rounded-sm bg-[#E3BC55] text-black font-heading font-bold uppercase tracking-widest text-xs hover:bg-[#FFD700] transition-colors flex items-center gap-1.5 disabled:opacity-50"
        >
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Invia
        </button>
      </div>
      <p className="text-[10px] text-slate-600">Arriva solo ai dispositivi che hanno attivato le notifiche (icona campanella nell'header). Le notifiche di scadenza (3g, 1g, 10h, 3h, 1h) sono automatiche.</p>
    </div>
  );
}
